const parseCoord = (value) => {
  if (value === null || value === undefined || value === '') return null;
  const num = Number(value);
  return Number.isFinite(num) ? num : null;
};

export const getHotelCoordinates = (hotel) => {
  if (!hotel) return null;
  const pairs = [
    [hotel.location?.lat, hotel.location?.lng],
    [hotel.location?.lat, hotel.location?.lon],
    [hotel.gps_coordinates?.latitude, hotel.gps_coordinates?.longitude],
    [hotel.latitude, hotel.longitude],
    [hotel.lat, hotel.lng],
  ];
  for (const [a, b] of pairs) {
    const lat = parseCoord(a);
    const lng = parseCoord(b);
    if (lat != null && lng != null && (lat !== 0 || lng !== 0)) {
      if (lat >= -90 && lat <= 90 && lng >= -180 && lng <= 180) {
        return { lat, lng };
      }
    }
  }
  return null;
};
